import { useDoctorInfo } from 'modules/user/hooks/useDoctorInfo';
import { MobileNavbar } from './mobile-navbar';
import { WebNavbar } from './web-navbar';

export const Navbar = () => {
  const { data } = useDoctorInfo();
  return (
    <>
      <MobileNavbar data={data} />
      <WebNavbar data={data} />
    </>
  );
};
